import { Component, OnInit ,OnDestroy} from '@angular/core';
import { PdaSchedule, PdaScheduleModel } from "../../../models/sections/schedule";
import { Pagination } from 'src/app/common/models/pagination';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';
import { SchedulesServiceTsService } from './Service/schedules.service.ts.service';
import { Subscription } from 'rxjs';
import { PdaDataStore } from 'src/app/pda/store/pda-store';
import { PdaAccessToken, PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { mockScheduleValues } from 'src/app/pda/utils/mock/schedule-mock-values';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';

@Component({
  selector: 'app-pda-section-schedules',
  templateUrl: './pda-section-schedules.component.html',
  styleUrls: ['./pda-section-schedules.component.css']
})
export class PdaSectionSchedulesComponent implements OnDestroy,OnInit {

  isSelectMode: boolean = false;
  selectMsg: string = "Seleziona dati da importare";
  selectedSchedules: PdaSchedule[] = [];

  tlfSub: Subscription;
  pctSub: Subscription;

  config = pdaConfiguration;
  idFascicoloTlf : string;
  model: PdaScheduleModel;

  currentSchedules: PdaSchedule[];
  currentPage: number = 0;
  currentItemsPerPage: number = 10;
  resetCurrentPage: boolean = false;

  constructor(private SectionService: SectionsServiceTsService, private schedulesService: SchedulesServiceTsService,
    private configService: ConfigurationService, private pdaAuthService: PdaAuthService
  ){

    // this.setCurrentSchedules();
  }
  ngOnDestroy(): void {
    if(this.tlfSub) this.tlfSub.unsubscribe();
    if(this.pctSub) this.pctSub.unsubscribe();
  }

  ngOnInit(): void {
    this.getIdFascicoloTlf();
    this.getData();
    // this.model = mockScheduleValues();
    // this.setCurrentSchedules();
  }

  async updatePct() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.SectionService.updatePCT(token, this.idFascicoloTlf, "adempimenti").subscribe(
      data => {
        this.setSchedules(data);
        if(this.configService.isFeatureEnabled(ConfigurationFeature.JUSTICE_PDA_SCHEDULE_AUTOIMPORT)) this.schedulesService.onNextImportScadenze();
      }
    )
  }

  getIdFascicoloTlf () {
    let index = this.config.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    this.idFascicoloTlf = this.config[index].properties.idFascicolo;
  }

  getData(){
    if(!PdaDataStore.isSameId(this.idFascicoloTlf)){
      PdaDataStore.cleanupStore();
      PdaDataStore.getInstance().idFascicoloTlf = this.idFascicoloTlf;
    }
    if(!!PdaDataStore.getInstance().modelSchedules) {
      this.model = PdaDataStore.getInstance().modelSchedules;
      this.setCurrentSchedules();
      return
    }

    this.tlfSub = this.SectionService.getIdFascicoloPCT(this.idFascicoloTlf).subscribe({
      next: (idPct) =>{
        if(idPct.length > 0) {
          let pct = idPct[0];
          this.pctSub = this.schedulesService.getSchedules(pct.idFascicoloPct).subscribe((data)=>{
            this.setSchedules(data);
          })
        }
      },error: () =>{}
    })
  }


  onRefresh(event: Pagination){

    this.currentPage = event.getCurrentPage();
    this.currentItemsPerPage = event.getItemsPerPage();

    this.setCurrentSchedules();

  }

  setSchedules(data: any){
    if(data.adempimenti && data.adempimenti.length > 0){
      data.adempimenti = data.adempimenti.sort((a, b) => (new Date(b.dataAdempimento).getTime() - new Date(a.dataAdempimento).getTime()));
    }
    this.model = { schedules : data.adempimenti , dataUltimoAggiornamento : data.dataUltimoAggiornamento };
    PdaDataStore.getInstance().modelSchedules = this.model;
    this.setCurrentSchedules();
  }

  setCurrentSchedules(){

    let currentIndex = this.currentPage* this.currentItemsPerPage;
    this.currentSchedules = this.model.schedules.slice(currentIndex,currentIndex+this.currentItemsPerPage);

  }

  changeSelectMode(){

    //Can only select if there are schedules to select
    if(this.model.schedules.length > 0){
      this.isSelectMode = !this.isSelectMode;

    //if selecting, then empty selected
    if(this.isSelectMode){
      this.selectMsg = "Importa dati";

      this.selectedSchedules = [];

    }
    //if not selecting, then confirm selected and save
    else{

      this.selectMsg = "Seleziona dati da importare";

      this.saveSelectedSchedules();

    }
    }

  }

  async saveSelectedSchedules(){
    let scadenzeRequest: string[] = [];

    let idFascicoloPct = this.selectedSchedules[0].idFascicoloPct;
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();

    if(this.selectedSchedules.length != 0){
      this.selectedSchedules.forEach((s) => {
        scadenzeRequest.push(s.idAdempimentoPct);
      });

      this.schedulesService.importScadenze(token, this.idFascicoloTlf, idFascicoloPct, scadenzeRequest).subscribe(
        data => {
          this.schedulesService.onNextImportScadenze();
          this.setSchedules(data);
        }
      );
    }


  }

  isScheduleSelected(schedule: PdaSchedule){

    return this.selectedSchedules.some(s => s == schedule);

  }

  onClickSelected(schedule: PdaSchedule){

    if(this.isScheduleSelected(schedule)) this.onSelectedRemove(schedule);
    else this.onSelectedAdd(schedule);

  }

  onSelectedAdd(schedule: PdaSchedule){

    this.selectedSchedules.push(schedule);

  }

  onSelectedRemove(schedule: PdaSchedule){
    this.selectedSchedules = this.selectedSchedules.filter(s => s != schedule);
  }

}
